<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full mt-10 mb-6">
      <p class="text-gray-800 sm:pt-1 mb-6">
        Please authorize VIVA Finance Inc. to pull your credit and bankruptcy information.
      </p>
      <div class="py-4">
        <!-- <div class="mb-6">
          <div class="flex leading-none">
            <button
              aria-label="link"
              type="button"
              class="mt-1 flex-none border border-gray-500 bg-gray-300 w-4 h-4 focus:outline-none focus:border-primary flex items-center justify-center mr-2"
              @click="terms.plaid = !terms.plaid"
            >
              <i v-if="terms.plaid" class="fas fa-check text-sm font-bold text-green-500"></i>
            </button>
            <p class="text-xs leading-7">
              By checking this box, I am stating that I have read, understood, and agree to the
              <a
                target="_blank"
                rel="noopener"
                href="https://www.dwolla.com/legal/tos"
                class="underline text-blue-500 hover:text-secondary"
              >
                Terms of Service</a
              >
              &
              <a
                target="_blank"
                rel="noopener"
                href="https://www.dwolla.com/legal/privacy/"
                class="underline text-blue-500 hover:text-secondary"
              >
                Privacy Policy</a
              >
              of Dwolla and the
              <a
                target="_blank"
                rel="noopener"
                href="https://plaid.com/legal/"
                class="underline text-blue-500 hover:text-secondary"
                >Terms & Conditions</a
              >
              and the
              <a
                target="_blank"
                rel="noopener"
                href="https://plaid.com/legal/#end-user-privacy-policy"
                class="underline text-blue-500 hover:text-secondary"
                >Privacy Policy</a
              >
              of Plaid.
            </p>
          </div>
        </div> -->

        <div class="mb-6">
          <div class="flex leading-none">
            <button
              aria-label="link"
              type="button"
              class="mt-1 flex-none border border-gray-500 bg-gray-300 w-4 h-4 focus:outline-none focus:border-primary flex items-center justify-center mr-2"
              @click="terms.plaid = !terms.plaid"
            >
              <i v-if="terms.plaid" class="fas fa-check text-sm font-bold text-green-500"></i>
            </button>
            <p class="text-xs leading-7">
              By submitting, you agree to the
              <a
                target="_blank"
                rel="noopener"
                href="https://plaid.com/legal/#consumers"
                class="underline text-blue-500 hover:text-secondary"
                >Terms & Conditions</a
              >
              and the
              <a
                target="_blank"
                rel="noopener"
                href="https://plaid.com/legal/#end-user-privacy-policy"
                class="underline text-blue-500 hover:text-secondary"
                >Privacy Policy</a
              >
              of Plaid.
            </p>
          </div>
        </div>

        <div class="mb-10">
          <div class="flex items-start leading-none">
            <button
              type="button"
              aria-label="terms"
              class="mt-1 border border-gray-500 bg-gray-300 w-4 h-4 focus:outline-none focus:border-primary flex items-center justify-center mr-2"
              @click="terms.experian = !terms.experian"
            >
              <i v-if="terms.experian" class="fas fa-check text-sm font-bold text-green-500"></i>
              <p v-else class="p-2"></p>
            </button>
            <p class="text-xs leading-7">
              By checking this box, I authorize VIVA to obtain credit histories, other consumer
              reports, and related information about me from credit reporting agencies such as
              Equifax, Experian, and/or TransUnion. Under the Fair Credit Reporting Act ("FCRA"), I
              am authorizing VIVA to obtain my personal credit history and use this information to
              evaluate my loan application. You can review a copy of our
              <a
                target="_blank"
                rel="noopener"
                href="https://storage-staging-assets-1kffmuraphfuf.s3.amazonaws.com/Sample+Credit+History+Authorization.pdf"
                class="underline text-blue-500 hover:text-secondary"
                >Credit History Authorization</a
              >
              before proceeding.
            </p>
          </div>
        </div>
        <div class="flex w-full mt-4">
          <button
            class="hover:text-primary mr-auto focus:outline-none rounded"
            type="btn"
            aria-label="navigate back"
            v-on:click="$emit('back')"
          >
            <i
              class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
            ></i>
          </button>

          <base-button
            :class="` ${!consented ? 'opacity-50' : ''}`"
            type="primary ml-auto"
            :disabled="!consented || buttonLoading"
            aria-label="navigate next"
            @click="handleNext()"
            ><i v-if="buttonLoading" class="fa fa-spinner fa-spin mr-2"></i>
            Next
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'PlaidDwollaCreditConsent',
  data: function () {
    return {
      terms: {
        plaid: false,
        experian: false
      },
      buttonLoading: false
    }
  },
  computed: {
    consented() {
      return this.terms.plaid && this.terms.experian
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  },
  methods: {
    getRejectionReason() {
      return this.$store.getters.preQualificationFailureReason
    },
    shouldPullHardCredit() {
      // TODO: Check what this should be
      return this.getRejectionReason().includes('credit')
    },
    async handleNext() {
      /**
       * App flow rewrite new logic:
       *
       * 1. If user is not prequal-rejected and does not
       * have a prequal rejection reason, then continue to
       * next page.
       *
       * 2. If rejection reason contains credit reasons
       * pull hard credit now and here and if user is rejected
       * then show rejection page.
       */
      if (this.shouldPullHardCredit()) {
        this.buttonLoading = true
        const data = await this.pulls()
        this.buttonLoading = false
        console.log(`data: ${JSON.stringify(data)}`)
        const { nextRoute } = data
        console.log(`nextRoute: ${nextRoute}`)
        this.$emit('next', nextRoute)
      } else {
        this.$emit('next', 'fundingAccount')
      }
    },
    handleBack() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('back')
    },
    async pulls() {
      /**
       * TODO CIRITCAL: Make sure pullCreditScoreOnly here is
       * set to true
       */
      const username = this.$store.getters.username
      return new Promise((resolve, reject) => {
        this.$apiClient
          .mutate({
            mutation: gql(
              `mutation { pulls(username: "${username}", hardPull: ${true}, pullCreditScoreOnly: ${true}, adminRequest: ${false} ) {
                isDenied
                reason
                rejectionReason
                nextRoute
              }}`
            )
          })
          .then(({ data }) => {
            console.log(data)
            /**
             * 302: A credit report has already been fetched
             * 303: Rejected at hard credit pull
             */
            if (data.pulls === 302) {
              console.log('A credit report has already been pulled for this user')
            }
            resolve(data.pulls)
          })
          .catch((e) => {
            console.log(e)
            reject(e)
          })
      })
    }
  }
}
</script>

<style scoped></style>
